<app-content configuration="config"></app-content>